module.exports = __webpack_public_path__ + "aa71c38e654362847c53451dc7132e54.pdf";